/**
 * Implement OAuth2 authentication flows for Amazon Cognito
 *
 * Configuration:
 * - process.env.AWS_COGNITO_CLIENT_ID
 * - process.env.AWS_COGNITO_REDIRECT_URI
 * - process.env.AWS_COGNITO_USER_POOL_DOMAIN
 * - process.env.AWS_COGNITO_LOGIN_PROVIDER_NAME
 */

import AWS from 'aws-sdk'
import axios from 'axios'

export async function getOAuth2Token (code) {
  const tokenConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

  const data = {
    'grant_type': 'authorization_code',
    'client_id': process.env.AWS_COGNITO_CLIENT_ID,
    'code': code,
    'redirect_uri': process.env.AWS_COGNITO_REDIRECT_URI
  }

  const url = `https://${process.env.AWS_COGNITO_USER_POOL_DOMAIN}/oauth2/token`
  const tokenResult = await axios.post(url, new URLSearchParams(data), tokenConfig)

  if (tokenResult.status !== 200) {
    throw new Error(`Error retrieving OAuth2 token: ${tokenResult.data}`)
  }

  return tokenResult.data
}

export async function refreshOAuth2Token (refreshToken) {
  const tokenConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

  const data = {
    'grant_type': 'refresh_token',
    'client_id': process.env.AWS_COGNITO_CLIENT_ID,
    'refresh_token': refreshToken
  }

  const url = `https://${process.env.AWS_COGNITO_USER_POOL_DOMAIN}/oauth2/token`
  const tokenResult = await axios.post(url, new URLSearchParams(data), tokenConfig)

  if (tokenResult.status !== 200) {
    throw new Error(`Error retrieving OAuth2 token: ${tokenResult.data}`)
  }

  return tokenResult.data
}

export async function getUserInfo (jwtToken) {
  const userinfoConfig = {
    headers: {
      'Authorization': `Bearer ${jwtToken}`
    }
  }

  const url = `https://${process.env.AWS_COGNITO_USER_POOL_DOMAIN}/oauth2/userInfo`
  const userinfoResult = await axios.post(url, {}, userinfoConfig)

  if (userinfoResult.status !== 200) {
    throw new Error(`Error retrieving userInfo: ${userinfoResult.data}`)
  }

  return userinfoResult.data
}

export async function getAwsCredentials (idToken) {
  const cognitoidentity = new AWS.CognitoIdentity({ region: process.env.AWS_REGION })

  const getIdParams = {
    AccountId: process.env.AWS_ACCOUNT_ID,
    IdentityPoolId: process.env.AWS_COGNITO_IDENTITY_POOL_ID,
    Logins: {}
  }

  getIdParams.Logins[process.env.AWS_COGNITO_LOGIN_PROVIDER_NAME] = idToken
  const idResponse = await cognitoidentity.getId(getIdParams).promise()
  const identityId = idResponse.IdentityId

  const getCredentialsForIdentityParams = {
    IdentityId: identityId,
    Logins: {}
  }

  getCredentialsForIdentityParams.Logins[process.env.AWS_COGNITO_LOGIN_PROVIDER_NAME] = idToken
  const credentialsResponse = await cognitoidentity.getCredentialsForIdentity(getCredentialsForIdentityParams).promise()

  return credentialsResponse.Credentials
}



// WEBPACK FOOTER //
// ./src/services/cognito.js